export default __webpack_public_path__ + "static/media/ic-file-image.a2a3f3e9.svg";